<template>
  <div>
    <button class="btn btn-primary" data-toggle="modal" :data-target="'#' + id">
      Click
    </button>
    <div class="modal fade" tabindex="-1" role="dialog" :id="id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div class="modal-footer">
            <button type="button" @click="ok()" class="btn btn-primary">
              {{ okText }}
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="cancel()"
            >
              {{ closeText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: {
    id: { type: String, default: 'modal-dialog' },
    title: { type: String, default: 'Title' },
    okText: { type: String, default: 'Ok' },
    closeText: { type: String, default: 'Cancel' }
  },
  methods: {
    ok() {
      this.$emit('okClicked', 'OK_CLICKED');
    },
    cancel() {
      this.$emit('cancelClicked', 'CANCEL_CLICKED');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
